// src/pages/FAQ.jsx
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import FAQSection from "../components/FAQ/FAQSection";

const FAQ = () => (
  <Layout>
    <Breadcrumb
      title="Câu hỏi thường gặp"
      parent={{ name: "Trang chủ", path: "/" }}
    />

    <FAQSection />
  </Layout>
);

export default FAQ;
